import Vue from 'vue';
import { mapGetters } from 'vuex';

export default Vue.component('grid-column', {
  template: require('./template.html'),
  name: 'grid-column',
  computed: {
    ...mapGetters([
      'currentPage',
      'globalDragEl',
      'dragging',
    ]),
    watchDroplets() {
      const drps = this.column.droplets;
      let cls = '';
      if (drps.length < 1) {
        cls = 'drzDroplet-puddleDropped';
      }
      return cls;
    },
    roamingTemplate() {
      return this.currentPage.type !== 'template' && this.droplet.templateRegion;
    },
    draggingTemplateDrp() {
      return this.globalDragEl === 'templateDroplet';
    },
  },
  props: [
    'column',
    'droplet',
    'display',
    'col-index',
    'descendants',
  ],
  watch: {
    'column.droplets': function watchDroplets() {
      // bouncing the component key will force a re-render. This is needed
      // for dragula to re insert the draggable container. See @/directives/main.js
      this.renderKey = Date.now();
    },
  },
  data() {
    const renderKey = Date.now();
    return {
      renderKey,
    };
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/grid/components/column/index.js